import { GET_SHOP_ADMIN_DASHBOARD_ORDER_DATA } from "../constants/endpoints";
import axiosClient from "./axios";

class fetchShopAdminDashboardOrderData {
  static async getShopAdminDashboardOrderData(
    startDate: string | null = null,
    endDate: string | null = null
  ) {
    const filters = {
      startDate: startDate !== null ? startDate : undefined,
      endDate: endDate !== null ? endDate : undefined,
    };

    return await axiosClient.post(GET_SHOP_ADMIN_DASHBOARD_ORDER_DATA, {
      filters: filters,
    });
  }
}

export default fetchShopAdminDashboardOrderData;
